import { IOfferFeatures } from '../../../types';

export const prepareFeatures = ({
  objectType,
  totalArea,
  landStatus,
  landArea,
  floorInfo,
  bedroomsCount,
}: IOfferFeatures): string[] =>
  [objectType, totalArea, landArea, landStatus, floorInfo, bedroomsCount].filter(Boolean) as string[];
